// extracted by mini-css-extract-plugin
export default {"banner":"h0dhogKV5qEnX50yclg7ew==","title":"kbbyQQVg1BpyVpaeoGG3gg==","description":"_4zEdZnTg6Rymrid3lvBzjw==","button":"DQgVhI9TWHsSvpr3MTH4QQ=="};